import React from 'react'
import { observer } from 'mobx-react-lite'
import useClassPresentationSubmission from './hooks/useClassPresentationSubmission'
import s from './styles/ClassPresentationSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const ClassPresentationSubmission = observer(({ assignment, student }) => {
	const { responseText, hasResponse } = useClassPresentationSubmission({
		assignment,
		student,
	})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>
					<div className={sharedStyles.textArea}>
						{hasResponse ? (
							<p className={sharedStyles.textContent}>{responseText}</p>
						) : (
							<div className={sharedStyles.empty}>
								No response submitted yet
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
})

ClassPresentationSubmission.displayName = 'ClassPresentationSubmission'

export default ClassPresentationSubmission
